const formatValue = (value, maximumFractionDigits = 2) => {
    return Number(value).toLocaleString('en-AU', {maximumFractionDigits});
}

const formatDate = (value) => {
    const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
    const date = new Date(dateOnly ? `${value}T00:00:00` : value);
    if(Number.isNaN(date.getTime())) return value;
    return date.toLocaleString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        ...(dateOnly ? {} : {hour: 'numeric', minute: '2-digit'}),
    });
}

const getParameterLabel = (parameter) => {
    const labels = {
        discharge: 'Flow',
        level: 'Level',
        storage_level: 'Storage level',
        storage_volume: 'Storage volume',
    };
    return labels[parameter] || 'Reading';
}

const getTailwaterLink = (entity, live) => {
    const syncKey = entity.meta?.tailwater_sync_key || '';
    if(!live.page || !syncKey.startsWith('c:')) return live.page;
    return `${live.page}${live.page.includes('?') ? '&' : '?'}loc=${encodeURIComponent(syncKey.substring(2))}`;
}

const TailwaterLive = ({ entity }) => {
    const live = entity.tailwater_live;
    if(!live || live.value === null || live.value === undefined) return null;

    const link = getTailwaterLink(entity, live);

    return <div className="atf-tailwater-live">
        <div className="atf-tailwater-live-station">🌊 {live.station || 'Nearby river gauge'}</div>
        <div className="atf-tailwater-live-pills">
            <div className="atf-tailwater-live-pill">
                <span className="label">{getParameterLabel(live.parameter)}</span>
                <span className="value">{formatValue(live.value)} {live.unit || ''}</span>
            </div>
            {live.water_temp !== null && live.water_temp !== undefined ?
            <div className="atf-tailwater-live-pill">
                <span className="label">Water temp</span>
                <span className="value">{formatValue(live.water_temp, 1)}°C</span>
            </div>
            : null}
            {live.date ?
            <div className="atf-tailwater-live-pill">
                <span className="label">Last updated</span>
                <span className="value">{formatDate(live.date)}</span>
            </div>
            : null}
        </div>
        {link ?
        <a className="atf-tailwater-live-link" href={link} target="_blank" rel="noreferrer">
            More conditions in Tailwater →
        </a>
        : null}
        <div className="atf-tailwater-live-credit">{live.credit || live.source || 'Source: Bureau of Meteorology'}</div>
    </div>
}

export default TailwaterLive
